import ExceptionHandling from './ExceptionHandling.js'
import { useStore, ActionTypes } from "../store";
import instance from './index';

export default class ProductService {


	getProducts(keyword,storeID,start,limitation) {
		//console.log("products limitation ", limitation);
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/product_list';
		const formData = new FormData();
		formData.append('keyword', keyword);
		formData.append('storeID', storeID);
		formData.append('start', start);
		formData.append('limitation', limitation);
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
		.catch((e) => ExceptionHandling.HandleErrors(e))
		.finally(() => {
			store.dispatch(ActionTypes.PROGRESS_BAR, false);
		})
	}


	getItems() {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/get_product_filters';
		return instance()(
			{
				method: 'get',
				url: api
			}
		).then(res => res.data)
		.catch((e) => ExceptionHandling.HandleErrors(e))
		.finally(() => {
			store.dispatch(ActionTypes.PROGRESS_BAR, false);
		})
	}

	save(postObj) {
		//SHOW LOADING
		//console.log("save function in product service");
		//console.log("save function in product obj ",postObj);
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/save_csv_product_data';
		const formData = new FormData();
		formData.append('items', JSON.stringify(postObj));
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}

	
	saveRowData(postObj) {
		//SHOW LOADING
		//console.log("save function in product service");
		//console.log("save function in product obj ",postObj);
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
	const api = '/api/save_product_row_data';
		const formData = new FormData();
		formData.append('item', JSON.stringify(postObj));
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}
    exportSampleProducts()
    {
		
        const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/export_sample_products';
		const formData = new FormData();
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
    }


	uploadProducts(csv_file) {
		//console.log("import smaple products js");
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/upload_products';
		const formData = new FormData();
		formData.append('csv_file', csv_file);

		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}

	uploadCSVFile(image) {
		//console.log("import smaple products js");
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/import_sample_products';
		const formData = new FormData();
		formData.append('image', image);

		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}

	updateItem(postObj,stateObj) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/update_stock';
		const formData = new FormData();
		formData.append('id', postObj.id);
		formData.append('product_name', stateObj.productName);
		formData.append('generic', stateObj.generic);
		formData.append('barcode', postObj.barcode);
		formData.append('type', stateObj.productType);
		formData.append('description', postObj.description);
		formData.append('brand', stateObj.brand);
		formData.append('brand_sector', stateObj.brandSector);
		formData.append('category', stateObj.category);
		formData.append('side_effects', postObj.sideEffects);
		formData.append('pack_size', stateObj.packSize);
		formData.append('strip_size', stateObj.stripSize);
		formData.append('expiry_date', stateObj.expiryDate);
		formData.append('qty', stateObj.unitQty);
		formData.append('sale_price', postObj.packSelling);
		formData.append('purchase_price', stateObj.packPurchase);
		formData.append('mrp', stateObj.mRP);
		formData.append('batch_no', stateObj.batchNo);
		formData.append('tax_1', postObj.tax_1);
		formData.append('tax_2', postObj.tax_2);
		formData.append('tax_3', postObj.tax_3);
		formData.append('discount_percentage', stateObj.disc);
		formData.append('min_stock', stateObj.minStock);
		formData.append('item_location', stateObj.storeLocation);
	
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}

	getItem(data) {
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		
		const api = '/api/get_product/' + data.id; // Make sure this is the PRODUCT ID
		return instance().get(api)
			.then(res => {
				//console.log('Item fetched:', res.data);
				return res.data;
			})
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			});
	}
	

	deleteItem(id) {
		//SHOW LOADING
		//console.log("DELETE ITEM SERVICE FUNCTION ",id);
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/delete_product';
		const formData = new FormData();
		formData.append('id', id);
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
		.catch((e) => ExceptionHandling.HandleErrors(e))
		.finally(() => {
			store.dispatch(ActionTypes.PROGRESS_BAR, false);
		})
	}

	activateItem(data) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/activate_stock';
		const formData = new FormData();
		formData.append('id', data.id);
		formData.append('status', data.status);
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
		.catch((e) => ExceptionHandling.HandleErrors(e))
		.finally(() => {
			store.dispatch(ActionTypes.PROGRESS_BAR, false);
		})
	}
}